// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__7L0C0","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1ARdZ"};